import * as THREE from "three";
import { useGLTF } from "@react-three/drei";
import { FACADES } from "./constants/facades";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const WallsGenerator = ({ walls, rowIndex, colIndex }) => {
  const { nodes } = useGLTF("/wall.glb");

  const areWallsHidden = useSelector(
    (state) => state.configurator?.areWallsHidden
  );

  const wallPosition = useMemo(() => {
    return {
      north: [0, 0, -0.5],
      east: [0.5, 0, 0],
      south: [0, 0, 0.5],
      west: [-0.5, 0, 0],
    };
  }, []);

  return FACADES.map((facade) => {
    if (walls[facade].color) {
      const { color } = walls[facade];
      return (
        <group
          key={`wall-${rowIndex}-${colIndex}-${facade}`}
          position={wallPosition[facade]}
          rotation-y={["west", "east"].includes(facade) ? Math.PI / 2 : 0}
          visible={areWallsHidden}
        >
          <mesh castShadow receiveShadow geometry={nodes.well.geometry}>
            <meshStandardMaterial
              color={`rgb(${color.r}, ${color.g}, ${color.b})`}
              opacity={color.a}
              transparent
              side={THREE.DoubleSide}
            />
          </mesh>
        </group>
      );
    } else return null;
  });
};

export default WallsGenerator;
